import { ArrivedConfig } from './ArrivedConfig';

const baseHref = process.env['NX_BASE_HREF'] ?? 'ERROR';
const PUBLIC_APP_ROOT = process.env['NX_PUBLIC_APP_ROOT'] ?? 'ERROR';
const WEB_APP_ROOT = process.env['NX_WEB_APP_ROOT'] ?? 'ERROR';
const ABACUS_ROOT = process.env['NX_ABACUS_ROOT'] ?? 'ERROR';
const REWARDS_ROOT = process.env['NX_REWARDS_ROOT'] ?? 'ERROR';
const ARRIVED_CMS_ROOT = process.env['NX_ARRIVED_CMS_ROOT'] ?? 'ERROR';
const CITY_PAGE_ROUTE = process.env['NX_CITY_PAGE_ROUTE'] ?? 'ERROR';
const HELP_PAGES_ROOT = process.env['NX_HELP_PAGES_ROOT'] ?? 'ERROR';
const MARKETING_API_ROOT = process.env['NX_MARKETING_API_ROOT'] ?? 'ERROR';
const BLOG_ROOT = process.env['NX_BLOG_ROOT'] ?? 'ERROR';
const DEMIO_API_ROOT = process.env['NX_DEMIO_API_ROOT'] ?? 'ERROR';

const AUTH0_AUDIENCE = process.env['NX_AUTH0_AUDIENCE'] ?? 'ERROR';
const AUTH0_CONNECTION = process.env['NX_AUTH0_CONNECTION'] ?? 'ERROR';
const AUTH0_DOMAIN_URL = process.env['NX_AUTH0_DOMAIN'] ?? 'ERROR';
const AUTH0_WEB_CLIENT_ID = process.env['NX_AUTH0_WEB_CLIENT_ID'] ?? 'ERROR';
const AUTH0_WEB_SCOPE = process.env['NX_AUTH0_WEB_SCOPE'] ?? 'ERROR';
const AUTH0_WEB_TOKEN_URL = process.env['NX_AUTH0_WEB_TOKEN_URL'] ?? 'ERROR';

const FACEBOOK_APP_ID = process.env['NX_FACEBOOK_APP_ID'] ?? 'ERROR';
const GOOGLE_API_KEY = process.env['NX_GOOGLE_API_KEY'] ?? 'ERROR';
const GOOGLE_TAG_MANAGER_ID = process.env['NX_GOOGLE_TAG_MANAGER_ID'] ?? 'ERROR';
const GROWTHBOOK_ROOT = process.env['NX_GROWTHBOOK_ROOT'] ?? 'ERROR';
const HEAP_APP_ID = process.env['NX_HEAP_APP_ID'] ?? 'ERROR';
const INTERCOM_ID = process.env['NX_INTERCOM_ID'] ?? 'ERROR';
const MAPBOX_ACCESS_KEY = process.env['NX_MAPBOX_ACCESS_KEY_WEB'] ?? 'ERROR';
const NEW_RELIC_APP_TOKEN_IOS = process.env['NX_NEW_RELIC_APP_TOKEN_IOS'] ?? 'ERROR';
const NEW_RELIC_APP_TOKEN_ANDROID = process.env['NX_NEW_RELIC_APP_TOKEN_ANDROID'] ?? 'ERROR';
const NEW_RELIC_APP_TOKEN_WEB = process.env['NX_NEW_RELIC_APP_TOKEN_WEB'] ?? 'ERROR';
const PLAID_ENVIRONMENT_NAME = process.env['NX_PLAID_ENVIRONMENT_NAME'] ?? 'ERROR';
const RUDDER_WRITE_KEY = process.env['NX_RUDDER_WRITE_KEY_WEB'] ?? 'ERROR';
const SENTRY_DSN_MOBILE = process.env['NX_SENTRY_DSN_MOBILE'] ?? 'ERROR';
const DEMIO_API_KEY = process.env['NX_DEMIO_API_KEY'] ?? 'ERROR';
const DEMIO_API_SECRET = process.env['NX_DEMIO_API_SECRET'] ?? 'ERROR';

/**
 * Base config; serves as a typed, organized wrapper for env variables and other static values.
 */
export const CONFIG: ArrivedConfig = {
  // Base paths for internal websites & services
  abacusApiRoot: ABACUS_ROOT,
  appRoot: `${PUBLIC_APP_ROOT}${baseHref}`,
  arrivedCmsApiUrl: ARRIVED_CMS_ROOT,
  helpUrl: HELP_PAGES_ROOT,
  marketingApiUrl: MARKETING_API_ROOT,
  baseHref,
  cityPageUrl: CITY_PAGE_ROUTE,
  learnBlogUrl: BLOG_ROOT,
  publicAppRoot: PUBLIC_APP_ROOT,
  demioApiRoot: DEMIO_API_ROOT,
  rewardsApiRoot: REWARDS_ROOT,
  socialShareUrlRoot: WEB_APP_ROOT,
  careersUrl: 'https://arrived.breezy.hr/',

  // Auth
  auth0: {
    audience: AUTH0_AUDIENCE,
    clientId: AUTH0_WEB_CLIENT_ID,
    connection: AUTH0_CONNECTION,
    domain: AUTH0_DOMAIN_URL,
    scope: AUTH0_WEB_SCOPE,
    tokenUrl: AUTH0_WEB_TOKEN_URL,
  },

  // Analytics & tools
  facebookAppId: FACEBOOK_APP_ID,
  googleApiKey: GOOGLE_API_KEY,
  googleTagManagerId: GOOGLE_TAG_MANAGER_ID,
  growthbookApiRoot: GROWTHBOOK_ROOT,
  heap: {
    appId: HEAP_APP_ID,
  },
  intercomId: INTERCOM_ID,
  mapboxAccessKey: MAPBOX_ACCESS_KEY,
  marketing: {
    tuneAffiliateBaseUrl: 'https://arrivedhomes.go2cloud.org',
  },
  newRelic: {
    newRelicAppTokenIos: NEW_RELIC_APP_TOKEN_IOS,
    newRelicAppTokenAndroid: NEW_RELIC_APP_TOKEN_ANDROID,
    newRelicAppTokenWeb: NEW_RELIC_APP_TOKEN_WEB,
  },
  plaid: {
    clientName: 'Arrived Homes',
    environment: PLAID_ENVIRONMENT_NAME,
  },
  rudderStack: {
    dataPlaneUrl: 'https://arrivedhomrdt.dataplane.rudderstack.com',
    rudderWriteKey: RUDDER_WRITE_KEY,
  },
  sentry: {
    mobileDsn: SENTRY_DSN_MOBILE,
  },
  demio: {
    apiKey: DEMIO_API_KEY,
    apiSecret: DEMIO_API_SECRET,
  },
};
